export default "__VITE_ASSET__DXQu8hoL__"